import { useState, useEffect, useCallback } from "react";
import { getPaymentBillingList, TGetPaymentBillingList } from "api/provider";
import { TPaymentBilling } from "types/provider";
import { set } from "lodash";


const usePatientPaymentBillingList = (param?: Partial<TGetPaymentBillingList>): [
    TPaymentBilling[] | undefined,
    number,
    boolean,
    (param?: Partial<TGetPaymentBillingList>) => void
] => {
    const [data, setData] = useState<TPaymentBilling[]>();
    const [total, setTotal] = useState<number>(0);
    const [loading, setLoading] = useState<boolean>(false);

    const fetchData = async (para: Partial<TGetPaymentBillingList> = {}) => {
        try {
            setLoading(true);
            // const { data, error } = await getPatientPaymentList();
            const res = await getPaymentBillingList({
                current: 1,
                size: 10,
                ...para,
            });
            if (!res.error) {
                const list = res.data?.data?.records || [];
                const amount = res.data?.data?.total;
                setTotal(amount || 0);
                setData(list);
            }
        } catch (err) {
            console.error("Payment list fetch error:", err);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchData(param);
    }, []);

    return [data, total, loading, fetchData];
};

export default usePatientPaymentBillingList;
